// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
* @description NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).  https://openapi-generator.tech  Do not edit the class manually.
*/
export var AccountPhoneContactInformationType;
(function (AccountPhoneContactInformationType) {
    AccountPhoneContactInformationType[AccountPhoneContactInformationType["UNKNOWN"] = 1] = "UNKNOWN";
    AccountPhoneContactInformationType[AccountPhoneContactInformationType["PHONE"] = 2] = "PHONE";
    AccountPhoneContactInformationType[AccountPhoneContactInformationType["MOBILE"] = 3] = "MOBILE";
})(AccountPhoneContactInformationType || (AccountPhoneContactInformationType = {}));
//# sourceMappingURL=accountPhoneContactInformationType.js.map